export default __webpack_public_path__ + "static/media/IconDesc_Ficsit_Coupon.256.64fb0654.png";